<template>
  <div>
    <nav></nav>
    <section>
      <p>Debido a las circunstancias de público conocimiento, esta área del sistema se encuentra deshabilitada.</p>
      <p>Por cualquier consulta, favor comunícarse con nosotros al +5411 5263-3434 opcion 8.</p>
      <p>Muchas Gracias</p>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex"
export default {
  name: "mensaje",
  components: {},
  mounted() {
    //   this.$router.push({name: 'cuposAereos'});
  },
  beforeCreate() {},
  methods: {
    ...mapActions("carrito", {
      limpiarCarrito: "limpiar"
    }),
    init() {
      this.limpiarCarrito()
      this.setApp()
      // this.$store.dispatch("app/setFormSave", null);
      //this.$store.dispatch("app/setFormSaveTicket", null);
    },
    setApp() {
      this.$store.dispatch("app/saveApp", this.$route.meta.app)
    }
  },
  data() {
    return {}
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  }
}
</script>
